import { render } from "./PlayerStatistics.vue?vue&type=template&id=25ba88ea"
import script from "./PlayerStatistics.vue?vue&type=script&lang=js"
export * from "./PlayerStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__